import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
  import { BehaviorSubject } from 'rxjs';
import { UsersSearchModel } from '../models/UserSearchModel';
import { AddUserModel } from '../models/add-user';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageUsersService {

  refreshDetails = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) { }

  GetEntityUsers(searchModel: UsersSearchModel, entityId: number): any {
    return this.http.post(`${environment.apiUrl}/CollectionEntity/GetEntityUsers?entityId=` + entityId, searchModel);
  }

  saveUser(update:any, user: AddUserModel, fileToUpload: any) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(user));
    if (fileToUpload.name) {
      formData.append('file', fileToUpload, fileToUpload.name);
    }
    let serviceUrl = `${environment.apiUrl}/accounts/AddUser`;
    if (update) {
      serviceUrl = `${environment.apiUrl}/accounts/EditUser`;
    }
    return this.http.post(serviceUrl, formData);
  }

  getPermissions() {
    return this.http.get(`${environment.apiUrl}/accounts/GetUserPagePermissions`);
  }

  GetUsers(searchModel: UsersSearchModel): any {
    return this.http.post(`${environment.apiUrl}/accounts/SearchUser`, searchModel);
  }

  getCounties() {
    return this.http.get(`${environment.apiUrl}/Lookup/Countries`);
  }

  getCities(id:any) {
    return this.http.get(`${environment.apiUrl}/Lookup/Cities/` + id);
  }

  getNotMembersUsers(collectionId:any) {
    return this.http.get(`${environment.apiUrl}/CollectionEntity/NotMembersUsers?collectionId=` + collectionId);
  }

  getNationalities() {
    return this.http.get(`${environment.apiUrl}/Lookup/Nationalities`);
  }

  deleteUser(id:any) {
    return this.http.delete(`${environment.apiUrl}/accounts/Delete/` + id);
  }
  deleteUsers(userIds:any): any {
    return this.http.post(`${environment.apiUrl}/accounts/DeleteUsers`, userIds);
  }
  deactivateUser(UsersObject:any) {
    return this.http.put(`${environment.apiUrl}/accounts/EditUserStatus`, UsersObject);
  }
  sendEmail(sendEmailObject:any) {
    return this.http.post(`${environment.apiUrl}/accounts/SendEmail`, sendEmailObject);
  }

  GetUser(id:any): any {
    return this.http.get(`${environment.apiUrl}/accounts/GetUser/` + id);
  }
  AssignMembershipNumberToUser(model:any): any {
    return this.http.put(`${environment.apiUrl}/accounts/AssignMembershipNumberToUser`, model);
  }
  getMembershipInfo(params:any): any {
    return this.http.get(`${environment.apiUrl}/accounts/GetMembershipInfo` , { params });
  }
  UploadSubscriberUsers(filetype:any, files: any) {
    const formData = new FormData();
    files.forEach((file:any) => {
      formData.append('file', file, file.name);
    });
    return this.http.post(`${environment.apiUrl}/Subscriber/UploadSubscriberUsers?fileType=` + filetype, formData);
  }
  getAllInternalUsers(): any {
    return this.http.get(`${environment.apiUrl}/Accounts/GetAllInternalUsers`);
  }
}
